import { GridRenderCellParams } from "@mui/x-data-grid-premium";

import CopyableTypography from "./CopyableTypography";

function copyableCell(stopPropagation: boolean) {
  return function renderCell({ value }: GridRenderCellParams) {
    if (value === null || value === undefined || value === "") return null;
    return (
      <CopyableTypography
        text={String(value)}
        variant="body2"
        stopPropagation={stopPropagation}
        // The value moves into a child div, where the grid's own ellipsis rule
        // no longer reaches it -- without this it wraps and clips vertically.
        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      />
    );
  };
}

/**
 * Grid `renderCell` for identifier columns (EPA IDs and the like) that readers
 * copy out far more often than they read.
 *
 * The click is consumed, so a row whose own click navigates somewhere stays
 * reachable through its other cells but not through this one. Where the row
 * click is the only way to select or edit the record, use
 * `renderCopyableCellKeepingRowClick` instead — copy must never be the reason a
 * record cannot be picked.
 */
export const renderCopyableCell = copyableCell(true);

/** Copies on click and lets the click reach the row as well. */
export const renderCopyableCellKeepingRowClick = copyableCell(false);
